// extracted by mini-css-extract-plugin
export default {"sidebar-item":"sidebar-item--ld1bN","sidebarItem":"sidebar-item--ld1bN","sidebar-item--active":"sidebar-item--active--eEnbz","sidebarItemActive":"sidebar-item--active--eEnbz"};